(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lspdp-bundle"] && !Shopify.designMode) return;
  try {
    // Koppelt de bundelkeuze aan het quantity-veld van het productformulier.
  // Horizon rendert dat veld als input[name="quantity"] binnen de product form.
  (function () {
    function setQuantity(scope, value) {
      var form =
        scope.closest('product-form-component') ||
        scope.closest('.shopify-section') ||
        document;
      var input = form.querySelector('input[name="quantity"]');
      if (!input) return;
      input.value = value;
      // Horizon luistert op change voor prijs- en cart-updates
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function bind(root) {
      root.querySelectorAll('[data-lsbundle] input[data-lsbundle-qty]').forEach(function (el) {
        if (el.dataset.lsbundleBound) return;
        el.dataset.lsbundleBound = '1';
        el.addEventListener('change', function () {
          if (el.checked) setQuantity(el, el.dataset.lsbundleQty);
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () { bind(document); });
    bind(document);
    // opnieuw binden na een section-render in de theme editor
    document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lspdp-daynight"] && !Shopify.designMode) return;
  try {
    (function () {
    var SUN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.4M12 19.1v2.4M4.3 4.3l1.7 1.7M18 18l1.7 1.7M2.5 12h2.4M19.1 12h2.4M4.3 19.7 6 18M18 6l1.7-1.7"/></svg>';
    var MOON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.5 14.2A8.5 8.5 0 0 1 9.8 3.5a8.5 8.5 0 1 0 10.7 10.7z"/></svg>';

    // File name of the image a slide shows, taken from whichever attribute the
    // theme has populated - lazy images may only carry srcset until they load.
    function slideFile(slide) {
      var img = slide.querySelector('img');
      if (!img) return '';
      var src = img.currentSrc || img.getAttribute('src') || (img.getAttribute('srcset') || '').split(/[\s,]/)[0] || '';
      try { src = decodeURIComponent(src); } catch (e) {}
      return src.split('/').pop().split('?')[0];
    }

    // "…_01_hero.jpg" -> "01_hero": the scene part of a listing-set file name.
    function sceneSuffix(file) {
      var m = file.match(/_([0-9]{2}_[a-z-]+)(?:_v[0-9]+)?\.[a-z]+$/i);
      return m ? m[1] : '';
    }

    // Keyword fallback (2026-10-12): the Liquid pick is the LAST match across all
    // colours, so for the visible colour it can be another colour's file whose
    // name has no scene suffix. Then look at the visible slides' file name and
    // alt text for the keywords themselves, "nightstand" removed.
    function keywordIndex(slideshow, words) {
      var all = slideshow.refs && slideshow.refs.slides ? slideshow.refs.slides : [];
      var hit = -1;
      for (var i = 0; i < all.length; i++) {
        if (all[i].hasAttribute('hidden')) continue;
        var img = all[i].querySelector('img');
        var hay = (slideFile(all[i]) + ' ' + (img ? img.getAttribute('alt') || '' : '')).toLowerCase().replace(/night ?stand/g, '');
        for (var w = 0; w < words.length; w++) {
          var ww = words[w].trim();
          if (ww && hay.indexOf(ww) !== -1) { hit = slideshow.slides.indexOf(all[i]); }
        }
      }
      return hit;
    }

    function findIndex(slideshow, file) {
      var all = slideshow.refs && slideshow.refs.slides ? slideshow.refs.slides : [];
      var pick = null;
      for (var i = 0; i < all.length; i++) {
        if (slideFile(all[i]) === file) { pick = all[i]; break; }
      }
      // Colour-filtered galleries only render (or unhide) the chosen colour's
      // slides, so the Liquid-chosen file can be missing or hidden. In both
      // cases fall back to the slide with the same scene suffix (the current
      // colour's own hero or daylight shot), preferring a visible one.
      if (!pick || pick.hasAttribute('hidden')) {
        var suf = sceneSuffix(file);
        if (suf) {
          for (var j = 0; j < all.length; j++) {
            if (!all[j].hasAttribute('hidden') && sceneSuffix(slideFile(all[j])) === suf) {
              pick = all[j];
              break;
            }
          }
        }
      }
      if (!pick) return -1;
      if (pick.hasAttribute('hidden')) {
        pick.setAttribute('reveal', '');
        pick.setAttribute('aria-hidden', 'false');
      }
      return slideshow.slides.indexOf(pick);
    }

    function build(cfg) {
      var gallery = document.querySelector('media-gallery');
      if (!gallery || gallery.querySelector('.lsdn')) return;
      var slideshow = gallery.slideshow;
      if (!slideshow || !slideshow.refs || !slideshow.refs.slides) return;

      var dayIdx = findIndex(slideshow, cfg.day);
      var nightIdx = findIndex(slideshow, cfg.night);
      if (nightIdx < 0) nightIdx = keywordIndex(slideshow, cfg.nightWords);
      if (dayIdx < 0) dayIdx = keywordIndex(slideshow, cfg.dayWords);
      // No day photo in this colour (or none at all): the hero is the day scene,
      // same fallback as the Liquid side. Only a missing night photo hides the pill.
      if (dayIdx < 0) dayIdx = 0;
      if (nightIdx < 0 || nightIdx === dayIdx) return;

      var wrap = document.createElement('div');
      wrap.className = 'lsdn';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', cfg.labelDay + ' / ' + cfg.labelNight);

      function button(icon, label, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lsdn__btn';
        b.setAttribute('aria-label', label);
        b.setAttribute('aria-pressed', 'false');
        b.innerHTML = icon + '<span class="lsdn__txt">' + label + '</span>';
        b.addEventListener('click', function () {
          // Slides 3+ stay unrendered until the gallery is "actioned" (speed
          // rule in product-media-gallery-content); flag it before jumping.
          slideshow.setAttribute('actioned', '');
          slideshow.select(idx, undefined, { animate: true });
        });
        return b;
      }
      var dayBtn = button(SUN, cfg.labelDay, dayIdx);
      var nightBtn = button(MOON, cfg.labelNight, nightIdx);
      wrap.appendChild(dayBtn);
      wrap.appendChild(nightBtn);

      function sync(index) {
        dayBtn.setAttribute('aria-pressed', String(index === dayIdx));
        nightBtn.setAttribute('aria-pressed', String(index === nightIdx));
        // The dimming-level panels carry a caption bar along the bottom edge,
        // exactly where the pill sits; step aside on those slides.
        var cur = slideshow.slides && slideshow.slides[index];
        wrap.hidden = !!(cur && /dimming|light-colors/i.test(slideFile(cur)));
      }
      sync(slideshow.current);
      // Fired for clicks, swipes and thumbnail taps alike, so the pill always
      // shows where the gallery actually is, not just what was last pressed.
      slideshow.addEventListener('slideshow:select', function (e) {
        sync(e.detail && typeof e.detail.index === 'number' ? e.detail.index : slideshow.current);
      });

      // Anchor to the container that wraps only the slides. The component
      // itself also holds the thumbnail strip beneath the image, so its bottom
      // edge is the thumbnails' bottom edge - the pill would land on them.
      var host = (slideshow.refs && slideshow.refs.slideshowContainer) ||
                 slideshow.querySelector('slideshow-container') || slideshow;
      host.appendChild(wrap);
    }

    function init() {
      var cfgEl = document.querySelector('[data-lspdp-daynight]');
      if (!cfgEl) return;
      var cfg = {
        day: cfgEl.dataset.day,
        night: cfgEl.dataset.night,
        labelDay: cfgEl.dataset.labelDay,
        labelNight: cfgEl.dataset.labelNight,
        nightWords: (cfgEl.dataset.nightWords || 'night,moody').split(','),
        dayWords: (cfgEl.dataset.dayWords || 'day').split(',')
      };
      // The gallery upgrades asynchronously; try until its slideshow is wired.
      var tries = 0;
      (function attempt() {
        var g = document.querySelector('media-gallery');
        if (g && g.slideshow && g.slideshow.refs && g.slideshow.refs.slides) { build(cfg); return; }
        if (++tries < 40) setTimeout(attempt, 150);
      })();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    // A colour or variant switch re-renders the gallery and throws the pill
    // away; this guard rebuilds it (build() is a no-op while one exists).
    if (!window.__lsdnTimer) {
      window.__lsdnTimer = setInterval(init, 1000);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lspdp-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
    // Amerikaanse federale feestdagen. Vul aan als je verder vooruit wilt rekenen.
    var HOL_US = {
      '2026': ['01-01','01-19','02-16','05-25','06-19','07-03','09-07','10-12','11-11','11-26','12-25'],
      '2027': ['01-01','01-18','02-15','05-31','06-18','07-05','09-06','10-11','11-11','11-25','12-24'],
      '2028': ['01-01','01-17','02-21','05-29','06-19','07-04','09-04','10-09','11-10','11-23','12-25']
    };
    // Britse bank holidays (Engeland en Wales), gebruikt als de bezoeker in de markt GB zit.
    var HOL_GB = {
      '2026': ['01-01','04-03','04-06','05-04','05-25','08-31','12-25','12-28'],
      '2027': ['01-01','03-26','03-29','05-03','05-31','08-30','12-27','12-28'],
      '2028': ['01-03','04-14','04-17','05-01','05-29','08-28','12-25','12-26']
    };
    var HOL = HOL_US;
    var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    function isHoliday(d) {
      var list = HOL[String(d.getFullYear())];
      if (!list) return false;
      var key = ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      return list.indexOf(key) > -1;
    }

    function isBusinessDay(d) {
      var w = d.getDay();
      return w !== 0 && w !== 6 && !isHoliday(d);
    }

    // Telt n werkdagen vooruit. Bestelt iemand zaterdag, dan begint de klok maandag.
    function addBusinessDays(from, n) {
      var x = new Date(from.getTime()), added = 0;
      while (!isBusinessDay(x)) x.setDate(x.getDate() + 1);
      while (added < n) {
        x.setDate(x.getDate() + 1);
        if (isBusinessDay(x)) added++;
      }
      return x;
    }

    function fmt(d) { return MON[d.getMonth()] + ' ' + d.getDate(); }

    function render(el) {
      var lo = parseInt(el.dataset.lo || '8', 10);
      var hi = parseInt(el.dataset.hi || '13', 10);
      var prefix = el.dataset.prefix || '';
      HOL = (el.dataset.cc === 'GB') ? HOL_GB : HOL_US;
      var now = new Date();
      var a = addBusinessDays(now, lo);
      var b = addBusinessDays(now, hi);
      var txt = (lo === hi) ? fmt(a) : fmt(a) + ' – ' + fmt(b);
      if (prefix) txt = prefix + ' ' + txt;
      el.querySelectorAll('[data-lsdel-date]').forEach(function (n) { n.textContent = txt; });
    }

    // Icon spin. The CSS only animates once `lsdel--play` is present, so the
    // icons don't spin while the widget is off-screen, and without JS the
    // widget is simply static. Armed once per element; a re-render from the
    // theme editor (shopify:section:load) gets a fresh element and arms again.
    function arm(el) {
      if (el.dataset.lsdelArmed) return;
      el.dataset.lsdelArmed = '1';
      if (!('IntersectionObserver' in window)) { el.classList.add('lsdel--play'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('lsdel--play');
          io.unobserve(e.target);
        });
      }, { threshold: 0.4 });
      io.observe(el);
    }

    // A delivery estimate only makes sense for a variant that can be bought.
    // The theme swaps the selected variant into the buy form's hidden id input,
    // so the widget re-reads it on a short interval and hides for sold-out ones.
    function selectedVariantId(el) {
      var root = el.closest('.shopify-section') || document;
      var input = root.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (input && input.value) return input.value;
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      return m ? m[1] : null;
    }

    function syncAvailability(el) {
      var node = el.querySelector('[data-ls-avail]');
      if (!node) return;
      if (!el._lsAvail) {
        try { el._lsAvail = JSON.parse(node.textContent); } catch (e) { el._lsAvail = {}; }
      }
      var id = selectedVariantId(el);
      var ok = (id && Object.prototype.hasOwnProperty.call(el._lsAvail, id))
        ? el._lsAvail[id] === true
        : el.dataset.initialAvailable === 'true';
      if (el.hidden === ok) el.hidden = !ok;
    }

    function run() {
      document.querySelectorAll('[data-lsdel]').forEach(function (el) { syncAvailability(el); render(el); arm(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
    if (!window.__lsdelAvailTimer) {
      window.__lsdelAvailTimer = setInterval(function () {
        document.querySelectorAll('[data-lsdel]').forEach(syncAvailability);
      }, 800);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lspdp-havela"] && !Shopify.designMode) return;
  try {
    (function () {
    function reviewTarget() {
      return (
        document.querySelector('.jdgm-rev-widg') ||
        document.querySelector('.jdgm-widget:not(.jdgm-prev-badge)') ||
        document.querySelector('[class*="judge"]')
      );
    }

    function bind() {
      var stars = document.querySelectorAll('.rating-wrapper');
      stars.forEach(function (el) {
        if (el.dataset.lsScrollBound) return;
        el.dataset.lsScrollBound = '1';
        el.setAttribute('role', 'link');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-label', 'Scroll to reviews');
        el.style.cursor = 'pointer';
        function go(e) {
          var t = reviewTarget();
          if (!t) return;
          e.preventDefault();
          t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        el.addEventListener('click', go);
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') go(e);
        });
      });

      // Trust cards: one 3D pop each, a second apart, played once - and only
      // once the visitor has actually scrolled to them. Two gates, both needed:
      //   1. a real scroll has happened. Without this, a tall monitor that shows
      //      the cards at page load would fire the pop before anyone looked.
      //   2. the row is at least half on screen (IntersectionObserver).
      // The scroll listener is captured at document level because this page
      // scrolls inside an inner container, so `window` never sees the event.
      // The CSS keys off `lspdp-trust--pop`; until it lands the cards simply
      // sit at rest - nothing is hidden waiting for the animation.
      document.querySelectorAll('.lspdp-trust__badges').forEach(function (row) {
        if (row.dataset.lsPopArmed) return;
        row.dataset.lsPopArmed = '1';
        if (!('IntersectionObserver' in window)) { row.classList.add('lspdp-trust--pop'); return; }

        function watch() {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              e.target.classList.add('lspdp-trust--pop');
              io.unobserve(e.target);
            });
          }, { threshold: 0.5 });
          io.observe(row);
        }

        function onFirstScroll() {
          document.removeEventListener('scroll', onFirstScroll, true);
          watch();
        }
        document.addEventListener('scroll', onFirstScroll, { capture: true, passive: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind);
    } else {
      bind();
    }
    document.addEventListener('shopify:section:load', bind);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lspdp-price-sync"] && !Shopify.designMode) return;
  try {
    (function () {
    var HIDDEN = 'lspdp-price-hidden';
    var SYNCED = 'lspdp-sticky-synced';
    // Eén keer gevonden widget en sticky element onthouden. Geen
    // getBoundingClientRect: elke maatmeting dwingt een layout af, en op een
    // pagina waar apps blijven renderen liep dat op tot seconden hoofdthread
    // (Lighthouse 2026-09-14: Style & Layout 26 s gesimuleerd op mobiel).
    var state = { widget: null, sticky: null, observing: false, spaced: false };

    function cfg() {
      var el = document.querySelector('script[data-lspdp-price-sync]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    // De widget telt pas als hij echt rijen toont, niet als losse config-scripts.
    function bundlePresent() {
      if (state.widget && state.widget.isConnected) return state.widget;
      state.widget = null;
      var nodes = document.querySelectorAll('.kaching-bundles, kaching-bundle');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].tagName === 'SCRIPT') continue;
        if (nodes[i].querySelector('.kaching-bundles__bar')) { state.widget = nodes[i]; break; }
      }
      return state.widget;
    }

    // Horizon rendert de koopbox-prijs als <product-price>, en de sticky balk
    // als .sticky-add-to-cart__price. Beide expliciet pakken; een brede
    // ".price" selector raakt ook productkaarten en de cart.
    function themePrices() {
      var out = [];
      [].slice.call(document.querySelectorAll('product-price')).forEach(function (p) {
        if (p.closest('[class*="kaching"]')) return;
        if (!p.closest('.product-details, product-form-component')) return;
        out.push(p);
      });
      [].slice.call(document.querySelectorAll('.sticky-add-to-cart__price')).forEach(function (p) {
        out.push(p);
      });
      return out;
    }

    // Prijs en doorgestreepte prijs van de geselecteerde KaChing-rij. KaChing
    // zet de radio-input buiten de label, dus de selectie lees je het
    // betrouwbaarst van de --selected class op de rij, met de checked radio
    // als tweede bron.
    function selectedBundlePrice(widget) {
      var bar = widget.querySelector('.kaching-bundles__bar--selected');
      if (!bar) {
        var radio = widget.querySelector('input[type="radio"]:checked');
        bar = radio ? radio.closest('.kaching-bundles__bar') : null;
      }
      if (!bar) return null;
      var priceEl = bar.querySelector('.kaching-bundles__bar-price');
      if (!priceEl) return null;
      var price = (priceEl.textContent || '').replace(/\s+/g, ' ').trim();
      if (!price) return null;
      var fullEl = bar.querySelector('.kaching-bundles__bar-full-price');
      var full = fullEl ? (fullEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
      if (full === price) full = '';
      // Hoeveel stuks zitten er in de gekozen rij? Zonder dat las de balk als de
      // prijs van EEN lamp (Ronne 2026-10-13: "dan lijkt de prijs ineens heel duur
      // per stuk"). KaChing rendert per stuk een variantkiezer in de rij; lukt dat
      // niet, dan het eerste getal uit de rijtitel ("Set of 2").
      var qty = bar.querySelectorAll('.kaching-bundles__bar-variant').length;
      if (qty < 2) {
        var titleEl = bar.querySelector('.kaching-bundles__bar-title');
        var m = titleEl ? (titleEl.textContent || '').match(/(\d+)/) : null;
        qty = m ? parseInt(m[1], 10) : 1;
      }
      if (!(qty > 1)) qty = 1;
      return { price: price, full: full, qty: qty };
    }

    function syncSticky(widget) {
      var sel = selectedBundlePrice(widget);
      var bars = document.querySelectorAll('.sticky-add-to-cart__price');
      for (var i = 0; i < bars.length; i++) {
        var box = bars[i];
        if (!sel) { continue; }   // geen selectie te lezen: themaprijs laten staan
        var key = sel.price + '|' + sel.full + '|' + sel.qty;
        if (box.getAttribute('data-lspdp-key') === key && box.classList.contains(SYNCED)) continue;
        var html = '';
        if (sel.qty > 1) html += '<span class="lspdp-sticky-qty">' + sel.qty + ' for </span>';
        html += '<span class="price lspdp-sticky-price">' + sel.price + '</span>';
        if (sel.full) html += ' <s class="lspdp-sticky-compare">' + sel.full + '</s>';
        box.innerHTML = html;
        box.setAttribute('data-lspdp-key', key);
        box.classList.add(SYNCED);
      }
    }

    function apply() {
      var c = cfg();
      if (!c) return;
      var widget = bundlePresent();

      // Verbergen staat uit; alleen als het ooit weer aan gaat wordt de
      // themaprijs aangeraakt, en dan alleen bij een echte wijziging.
      if (c.hidePrice) {
        themePrices().forEach(function (p) {
          var wantHidden = !!widget;
          if (wantHidden && !p.classList.contains(HIDDEN)) p.classList.add(HIDDEN);
          if (!wantHidden && p.classList.contains(HIDDEN)) p.classList.remove(HIDDEN);
        });
      }

      if (widget && c.bundleSpacing && !state.spaced) {
        widget.style.marginBottom = c.bundleSpacing + 'px';
        state.spaced = true;
      }

      if (c.syncSticky && widget) syncSticky(widget);
      if (widget && !state.observing) observe(widget);
    }

    // Pas observeren als de widget er is, en dan alleen de widget zelf (rijwissel)
    // en de sticky balk (her-render door het thema). Niet document.body: dat
    // vuurde bij elke app-render en kostte seconden layout op mobiel.
    var scheduled = false;
    function scheduleApply() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; apply(); });
    }
    function observe(widget) {
      if (!window.MutationObserver) return;
      state.observing = true;
      new MutationObserver(scheduleApply).observe(widget, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
      var sticky = document.querySelector('sticky-add-to-cart');
      if (sticky) new MutationObserver(scheduleApply).observe(sticky, { childList: true, subtree: true });
    }

    function start() {
      apply();
      // KaChing rendert asynchroon; even blijven kijken tot hij er is
      var tries = 0;
      var iv = setInterval(function () {
        apply();
        if (state.observing || ++tries > 20) clearInterval(iv);
      }, 700);
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.name && String(t.name).indexOf('kaching-bundles-deal') === 0) {
          setTimeout(apply, 50);
          setTimeout(apply, 400);
        }
      }, true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    document.addEventListener('shopify:section:load', apply);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lspdp-scale"] && !Shopify.designMode) return;
  try {
    (function () {
    var CM_PER_INCH = 2.54;

    function inches(cm) {
      return Math.round((cm / CM_PER_INCH) * 10) / 10;
    }

    // Zoekt "Height: 42.5 cm" of "Hoogte: 42,5 cm" op de pagina.
    // Bewust textContent en niet innerText: de specs staan in een dichtgeklapte
    // accordion, en innerText slaat verborgen tekst over.
    function heightFromPage() {
      var text = document.body ? document.body.textContent : '';
      var m =
        text.match(/\b(?:height|hoogte)\s*[:\-]?\s*(\d+(?:[.,]\d+)?)\s*cm\b/i) ||
        text.match(/\b(\d+(?:[.,]\d+)?)\s*cm\s*(?:high|tall|hoog)\b/i);
      if (!m) return null;
      var v = parseFloat(m[1].replace(',', '.'));
      return isNaN(v) ? null : v;
    }

    function render(el) {
      var h = parseFloat(el.dataset.height);
      if (isNaN(h) || h <= 0) h = heightFromPage();
      if (!h || h <= 0) return; // niets te tonen, blok blijft verborgen

      var ref = parseFloat(el.dataset.reference) || 60;
      var tallest = Math.max(h, ref);
      var maxPx = 190;

      var prodBar = el.querySelector('[data-lsscale-prodbar]');
      var refBar = el.querySelector('[data-lsscale-refbar]');
      if (prodBar) prodBar.style.height = Math.round((h / tallest) * maxPx) + 'px';
      if (refBar) refBar.style.height = Math.round((ref / tallest) * maxPx) + 'px';

      var pl = el.querySelector('[data-lsscale-prodlabel]');
      var rl = el.querySelector('[data-lsscale-reflabel]');
      if (pl) {
        pl.textContent =
          (el.dataset.productLabel || 'This lamp') +
          ' · ' + h + ' cm (' + inches(h) + ' in)';
      }
      if (rl) {
        rl.textContent =
          (el.dataset.referenceLabel || 'Typical nightstand') +
          ' · ' + ref + ' cm (' + inches(ref) + ' in)';
      }

      el.hidden = false;
    }

    function run() {
      document.querySelectorAll('[data-lsscale]').forEach(render);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
    // specs zitten soms in een dichte accordion; nog een poging na de eerste render
    setTimeout(run, 900);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lspdp-units"] && !Shopify.designMode) return;
  try {
    (function () {
    var CM_PER_INCH = 2.54;

    function round(n, d) {
      var f = Math.pow(10, d);
      return Math.round(n * f) / f;
    }

    // "25.6 x 28.3 cm" -> "25.6 x 28.3 cm (10.1 x 11.1 in)"
    // "42.5 cm"        -> "42.5 cm (16.7 in)"
    function convert(text, decimals) {
      return text.replace(
        /(\d+(?:[.,]\d+)?(?:\s*[x×]\s*\d+(?:[.,]\d+)?)*)\s*cm\b/gi,
        function (match, numbers) {
          var parts = numbers.split(/\s*[x×]\s*/);
          var inches = parts.map(function (p) {
            var v = parseFloat(p.replace(',', '.'));
            if (isNaN(v)) return null;
            return round(v / CM_PER_INCH, decimals);
          });
          if (inches.some(function (i) { return i === null; })) return match;
          return match + ' (' + inches.join(' x ') + ' in)';
        }
      );
    }

    function alreadyDone(text) {
      return /\bin\)/.test(text) || /["″]/.test(text);
    }

    function walk(root, decimals) {
      if (!root) return;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          var p = node.parentElement;
          if (!p) return NodeFilter.FILTER_REJECT;
          if (p.closest('script, style, textarea, input, select')) {
            return NodeFilter.FILTER_REJECT;
          }
          if (p.dataset && p.dataset.lspdpUnitsDone) return NodeFilter.FILTER_REJECT;
          if (!/\d\s*cm\b/i.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
          if (alreadyDone(node.nodeValue)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      var nodes = [];
      var n;
      while ((n = walker.nextNode())) nodes.push(n);

      nodes.forEach(function (node) {
        var next = convert(node.nodeValue, decimals);
        if (next !== node.nodeValue) {
          node.nodeValue = next;
          if (node.parentElement && node.parentElement.dataset) {
            node.parentElement.dataset.lspdpUnitsDone = '1';
          }
        }
      });
    }

    function run() {
      var cfg = { decimals: 1, scope: 'page' };
      var el = document.querySelector('script[data-lspdp-units]');
      if (el) {
        try { cfg = Object.assign(cfg, JSON.parse(el.textContent)); } catch (e) {}
      }
      var root =
        cfg.scope === 'details'
          ? document.querySelector('.product-details, product-form-component')
          : document.body;
      walk(root || document.body, cfg.decimals);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    // accordions en varianten renderen soms later; opnieuw draaien
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('click', function (e) {
      if (e.target.closest('details, summary, accordion-custom')) {
        setTimeout(run, 120);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["qx-bundle-offer"] && !Shopify.designMode) return;
  try {
    (function () {
    function money(c) {
      var s = (Math.round(c) / 100).toFixed(2).split('.');
      return '$' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + s[1];
    }

    function init(root) {
      if (root.dataset.qxInit) return;
      root.dataset.qxInit = '1';
      var prices = {};
      try { prices = JSON.parse(root.querySelector('script[data-qx-prices]').textContent); } catch (e) {}
      var pct = Number(root.dataset.pct) || 0;
      var scope = root.closest('.shopify-section') || document;
      var last = '';

      function form() { return scope.querySelector('product-form-component form[action*="/cart/add"]') || scope.querySelector('form[action*="/cart/add"]'); }
      function qty() { var r = root.querySelector('.qx-bundle__input:checked'); return r ? Number(r.value) : 1; }

      function setQty(n) {
        var qs = scope.querySelector('product-form-component quantity-selector-component');
        var f = form();
        var input = (qs && qs.querySelector('input[name="quantity"]')) || (f && f.querySelector('input[name="quantity"]'));
        if (!input) return;
        if (qs && typeof qs.setValue === 'function') qs.setValue(String(n)); else input.value = String(n);
        if (qs && typeof qs.updateButtonStates === 'function') qs.updateButtonStates();
        // Sticky balk luistert naar dit event voor "Add to cart (2)"
        var ev = new Event('quantity-selector:update', { bubbles: true });
        ev.detail = { quantity: n, cartLine: undefined };
        input.dispatchEvent(ev);
      }

      function current() {
        var f = form();
        var idInput = f && f.querySelector('input[name="id"]');
        var p = idInput && prices[idInput.value];
        if (p == null) { for (var k in prices) { p = prices[k]; break; } }
        return p;
      }

      function render() {
        var p = current();
        if (p == null) return;
        var disc = Math.round(p * pct / 100);
        var full2 = p * 2;
        var price2 = full2 - disc;
        root.querySelector('[data-qx-price1]').textContent = money(p);
        root.querySelector('[data-qx-price2]').textContent = money(price2);
        root.querySelector('[data-qx-full2]').textContent = money(full2);
        var two = qty() === 2;
        // Zonder "2 for" las de balk als de prijs van een los artikel (Ronne 2026-10-13).
        var unit = (root.dataset.one === 'set') ? '2 sets for ' : '2 for ';
        var html = two
          ? '<span class="qx-sticky-qty">' + unit + '</span><span class="price qx-sticky-price">' + money(price2) + '</span> <s class="qx-sticky-compare">' + money(full2) + '</s>'
          : '<span class="price qx-sticky-price">' + money(p) + '</span>';
        var key = p + '|' + two;
        var boxes = document.querySelectorAll('.sticky-add-to-cart__price');
        for (var i = 0; i < boxes.length; i++) {
          if (boxes[i].getAttribute('data-qx-key') === key) continue;
          boxes[i].innerHTML = html;
          boxes[i].setAttribute('data-qx-key', key);
        }
        last = key;
      }

      function select() {
        var bars = root.querySelectorAll('.qx-bundle__bar');
        for (var i = 0; i < bars.length; i++) {
          var r = bars[i].querySelector('.qx-bundle__input');
          bars[i].classList.toggle('qx-bundle__bar--selected', !!(r && r.checked));
        }
        setQty(qty());
        render();
      }

      root.addEventListener('change', function (e) {
        if (e.target && e.target.classList.contains('qx-bundle__input')) select();
      });

      // Variantwissel: Horizon morpht de themaprijs en het verborgen id-veld.
      // Daarop meeliften is robuuster dan een theme-event dat per versie verschilt.
      var scheduled = false;
      function later() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          render();
          var f = form();
          var input = f && f.querySelector('input[name="quantity"]');
          if (input && Number(input.value) !== qty()) setQty(qty());
        });
      }
      if (window.MutationObserver) {
        var details = root.closest('.product-details') || scope;
        var prices1 = details.querySelectorAll('product-price');
        for (var i = 0; i < prices1.length; i++) new MutationObserver(later).observe(prices1[i], { childList: true, subtree: true, characterData: true });
        var sticky = document.querySelector('sticky-add-to-cart');
        if (sticky) new MutationObserver(function () { var b = document.querySelector('.sticky-add-to-cart__price'); if (b && b.getAttribute('data-qx-key') !== last) later(); }).observe(sticky, { childList: true, subtree: true });
      }
      scope.addEventListener('change', function (e) {
        if (e.target && !e.target.classList.contains('qx-bundle__input')) { setTimeout(later, 60); setTimeout(later, 500); }
      });

      // Aantalkiezer en Horizon-componenten laden als module na dit script.
      select();
      var tries = 0;
      var iv = setInterval(function () {
        var qs = scope.querySelector('product-form-component quantity-selector-component');
        if ((qs && typeof qs.setValue === 'function') || ++tries > 20) { clearInterval(iv); select(); }
      }, 300);
    }

    function start() {
      var nodes = document.querySelectorAll('[data-qx-bundle]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

})();
